import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { DEBOUNCE_DELAY } from "~/components/constants";
import { debounce } from "~/utils/debounce";

export const useLocationHash = () => {
	const [hash, setHash] = useState("");
	const router = useRouter();

	useEffect(() => {
		const handleHashChange = debounce(() => {
			setHash(window.location.hash);
		}, DEBOUNCE_DELAY);

		router.events.on("hashChangeStart", handleHashChange);

		// When the page changes, the "hashChangeStart" event doesn't get fired
		// so we need to update the hash on "routeChangeComplete" instead.
		router.events.on("routeChangeComplete", handleHashChange);
		setHash(window.location.hash);

		return () => {
			router.events.off("hashChangeStart", handleHashChange);
			router.events.off("routeChangeComplete", handleHashChange);
		};
	}, [router.events]);

	return hash;
};
